import { useContext } from 'react';
import { LayerListContext } from '../context';
export function useLayerItemsMap() {
    var itemsMap = useContext(LayerListContext).itemsMap;
    return itemsMap;
}
